import { schema } from 'normalizr';

const entitySchema = new schema.Entity('employee', undefined, { idAttribute: 'id' });

export default entitySchema;
